import { memo } from 'react';
import { TimeUnitPeriod } from '@mews-commander/data-access';
import { TimeUnit, UnicodeEntity } from '@mews/enums';
import { Parenthesized } from '../../typography';
import { LocalizedUtcTimeUnitFormat } from './enums';
import { LocalizedUtcDate } from './LocalizedUtcDate';
import { LocalizedUtcMonthYear } from './LocalizedUtcMonthYear';
import { LocalizedUtcShortDate } from './LocalizedUtcShortDate';
import { LocalizedUtcShortTime } from './LocalizedUtcShortTime';

interface LocalizedUtcTimeUnitProps {
    format?: LocalizedUtcTimeUnitFormat;
    timeUnit: TimeUnit | TimeUnitPeriod;
    utcString: string;
}

export const LocalizedUtcTimeUnit = memo(
    ({ format = LocalizedUtcTimeUnitFormat.Long, timeUnit, utcString }: LocalizedUtcTimeUnitProps) => {
        switch (timeUnit) {
            case TimeUnit.Hour:
                return (
                    <>
                        <LocalizedUtcShortTime utcString={utcString} />
                        {UnicodeEntity.NoBreakSpace}
                        <Parenthesized>
                            <LocalizedUtcDate utcString={utcString} />
                        </Parenthesized>
                    </>
                );
            case TimeUnit.Month:
                return <LocalizedUtcMonthYear utcString={utcString} />;
            default:
                return format === LocalizedUtcTimeUnitFormat.Short ? (
                    <LocalizedUtcShortDate utcString={utcString} />
                ) : (
                    <LocalizedUtcDate utcString={utcString} />
                );
        }
    }
);
